// Egress profiles (engineer: the API serves the list to engineers only) and
// the remote login window of one profile (operator+: openLogin is operator;
// the session is bound to whoever opened it).
import { operationMinRole } from '@/api/access'
import { defineFeatureRoutes } from '@/app/router/registry'
import { messages } from './i18n'

export const EGRESS_LOGIN_ROUTE = 'egress-login'

export default defineFeatureRoutes([
  {
    path: '/egress-profiles',
    name: 'egress-profiles',
    component: () => import('./EgressProfilesView.vue'),
    meta: {
      title: messages.lazy('title'),
      minRole: operationMinRole('listEgressProfiles') ?? undefined,
      nav: { order: 52, icon: 'egress', group: 'system', advanced: true },
    },
  },
  {
    path: '/egress-profiles/:id/login',
    name: EGRESS_LOGIN_ROUTE,
    component: () => import('./LoginView.vue'),
    props: true,
    meta: { title: messages.lazy('loginTitle'), minRole: operationMinRole('openLogin') ?? undefined },
  },
])
